import React, { useEffect, useState, useRef } from "react";
import "./PurchaseScreen.css";
import SelectPopup from "./SelectPopup";
import { getItems } from "./api/ItemApi";

const PURCHASE_API = "/api/purchases";
const SUPPLIER_API = "/api/suppliers";
/* ---------- EMPTY ROW ---------- */
const emptyRow = () => ({
  itemId: "",
  itemName: "",
  hsnCode: "",
  qty: "",
  rate: "",
  taxPercent: "",
  amount: "",
  remarks: "",
  unitValue: 0,
  unitType: "",
  totalWeightGrams: 0,
  totalKgDisplay: ""
});


export default function PurchaseScreen({goHome}) {

  /* ---------- MASTER DATA ---------- */
const [mobileTab, setMobileTab] = useState("list");

  const [items, setItems] = useState([]);
  
  /* ---------- HEADER ---------- */
  const [header, setHeader] = useState({
    id: null,
    purchaseNo: "",
    partyId: "",
    partyName: "",
    address: "",
    gstNo: "",
    date: new Date().toISOString().slice(0, 10),
    billNo: "",
    type: "",
    discount: 0,
    totalAmount: 0,
  });

  /* ---------- TABLE ---------- */
const isMobile = window.innerWidth <= 768;

const [rows, setRows] = useState(
  isMobile ? [emptyRow()] : [emptyRow(), emptyRow(), emptyRow(), emptyRow()]
);
  /* ---------- RIGHT LIST ---------- */
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");

  /* ---------- PARTY POPUP ---------- */
  const [showPartyPopup, setShowPartyPopup] = useState(false);
const [partySearch, setPartySearch] = useState("");
  const [suppliers, setSuppliers] = useState([]);
const [isAdding, setIsAdding] = useState(false);
const itemOptions = items.map(i => i.itemName);
const [popup,setPopup] = useState({
open:false,
field:"",
title:"",
options:[],
allowAdd:false,
rowIndex:null
});
const [newSupplier, setNewSupplier] = useState({
  name: "",
  address: "",
  gst: ""
});


useEffect(() => {
  getItems().then(setItems);
  loadList();
  loadNextPurchaseNo();
}, []);

const openPopup = (field,title,options,allowAdd=false)=>{
setPopup({
open:true,
field,
title,
options,
allowAdd
});
};

async function loadSuppliers() {
  const res = await fetch(SUPPLIER_API);
  const data = await res.json();
  setSuppliers(data);
}
  async function loadList() {
    const res = await fetch(PURCHASE_API);
    setList(await res.json());
  }

  async function loadNextPurchaseNo() {
    const res = await fetch(`${PURCHASE_API}/next-no`);
    const no = await res.text();
    setHeader(h => ({ ...h, purchaseNo: no }));
  }
async function loadPurchaseById(id) {
  const res = await fetch(`${PURCHASE_API}/${id}`);
  const data = await res.json();

  // 🔹 Load Header
  setHeader({
    id: data.id,
    purchaseNo: data.purchaseNo,
    partyId: data.partyId,
    partyName: data.partyName,
    address: data.address,
    gstNo: data.gstNo,
    date: data.purchaseDate,
    billNo: data.billNo || "",
    type: data.type || "",
    discount: data.discount || 0,
    totalAmount: data.totalAmount || 0,
  });

  // 🔹 Load Items
const loadedRows = data.items.map(item => {

  // 🔥 Always get unitValue from items master
  const itemMaster = items.find(
    x => String(x.id) === String(item.itemId)
  );

  const unitValue = itemMaster?.unitValue || item.unitValue || 0;
  const unitType = itemMaster?.unitType || item.unitType || "";
  const qty = Number(item.qty || 0);

  const totalWeightGrams = unitValue * qty;

  return {
    itemId: item.itemId,
    itemName: item.itemName,
    hsnCode: item.hsnCode,
    qty: item.qty,
    rate: item.rate,
    taxPercent: item.taxPercent,
    amount: item.amount,
    unitValue,
    unitType,
    totalWeightGrams,
    totalKgDisplay: totalWeightGrams + " " + unitType,
    remarks: item.remarks || ""
  };
});

  // ensure minimum 4 rows
  while (loadedRows.length < 4) {
    loadedRows.push(emptyRow());
  }

  setRows(loadedRows);
}

function onItemSelect(i, itemId) {

  const it = items.find(x => String(x.id) === itemId);
  if (!it) return;

  updateRow(i,{
    itemId: it.id,
    itemName: it.itemName,
    hsnCode: it.hsnCode,
    rate: it.rate,
    taxPercent: it.taxPercent,
    unitValue: it.unitValue,
    unitType: it.unitType
  });
}
  
function updateRow(i, changes) {

  setRows(rows =>
    rows.map((r, idx) => {

      if (idx !== i) return r;

      const next = { ...r, ...changes };

      const qty = Number(next.qty || 0);
      const rate = Number(next.rate || 0);

      const tax = qty * rate * (Number(next.taxPercent || 0) / 100);
      next.amount = (qty * rate + tax).toFixed(2);

      /* CORRECT UNIT CALCULATION */

      const unitValue = Number(next.unitValue || 0);
const totalUnit = qty * unitValue;

next.totalWeightGrams = totalUnit;

// 🔥 THIS IS THE FIX
next.totalKgDisplay = totalUnit + " " + (next.unitType || "");    // no kg conversion

      return next;
    })
  );
}
  /* ---------- TOTAL ---------- */
  useEffect(() => {
    const sum = rows.reduce((t, r) => t + Number(r.amount || 0), 0);
    setHeader(h => ({ ...h, totalAmount: sum.toFixed(2) }));
  }, [rows]);

 function handleButtonKey(e, index) {
  const buttons = document.querySelectorAll(".pur-actions button");

  if (e.key === "ArrowRight") {
    e.preventDefault();
    buttons[index + 1]?.focus();
  }

  if (e.key === "ArrowLeft") {
    e.preventDefault();
    buttons[index - 1]?.focus();
  }
}

  /* ---------- SAVE ---------- */
  async function handleSave() {

    const payload = {
      ...header,
      purchaseDate: header.date,
     items: rows
  .filter(r => r.itemId && r.qty)
  .map(r => ({
    itemId: r.itemId,
    itemName: r.itemName,
    hsnCode: r.hsnCode,
    qty: r.qty,
    rate: r.rate,
    taxPercent: r.taxPercent,
    amount: r.amount,
    remarks: r.remarks,

    unitValue: r.unitValue,
    unitType: r.unitType,
    totalWeightGrams: r.totalWeightGrams
  }))
    };

    const method = header.id ? "PUT" : "POST";
    const url = header.id ? `${PURCHASE_API}/${header.id}` : PURCHASE_API;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    await res.json();
    alert("Saved successfully");
    handleNew();
    loadList();
  }
function handleNew() {

  setHeader({
    id: null,
    purchaseNo: "",
    partyId: "",
    partyName: "",
    address: "",
    gstNo: "",
    date: new Date().toISOString().slice(0, 10),
    billNo: "",
    type: "",
    discount: 0,
    totalAmount: 0,
  });

  if (window.innerWidth <= 768) {
    setRows([emptyRow()]);
  } else {
    setRows([emptyRow(), emptyRow(), emptyRow(), emptyRow()]);
  }

  loadNextPurchaseNo();
}
  /* ---------- PARTY SELECT ---------- */
  function selectParty(p) {
  if (!p) return;

  setHeader(h => ({
    ...h,
    partyId: p.id,
    partyName: p.partyName,
    address: p.address || "",
    gstNo: p.gstin || ""
  }));

  setShowPartyPopup(false);
  setPartySearch("");
 
}

 

const filteredList = list
  .filter(p =>
    p.partyName?.toLowerCase().includes(search.toLowerCase())
  )
  .sort((a, b) =>
    (a.partyName || "").localeCompare(b.partyName || "", undefined, {
      sensitivity: "base"
    })
  );
const totalQty = rows.reduce(
  (sum, r) => sum + Number(r.qty || 0),
  0
);

const totalTax = rows.reduce((sum, r) => {
  const qty = Number(r.qty || 0);
  const rate = Number(r.rate || 0);
  const taxPercent = Number(r.taxPercent || 0);
  return sum + (qty * rate * taxPercent / 100);
}, 0);

const billAmount = rows.reduce(
  (sum, r) => sum + (Number(r.qty || 0) * Number(r.rate || 0)),
  0
);

const grandAmount = billAmount + totalTax;
const finalTotal = grandAmount - Number(header.discount || 0);

function addNewRow() {
  setRows(prev => [...prev, emptyRow()]);
}


function handleTableEnter(e, rowIndex, colIndex) {

  if (e.key === "Enter") {
    e.preventDefault();

    const maxRow = rows.length - 1;

    if (rowIndex === maxRow) {
      addNewRow();
    }

    requestAnimationFrame(() => {
      const next = document.querySelector(
        `[data-row="${rowIndex + 1}"][data-col="0"]`
      );
      next?.focus();
    });
  }

  if (e.key === "ArrowDown") {
    e.preventDefault();
    const next = document.querySelector(
      `[data-row="${rowIndex + 1}"][data-col="${colIndex}"]`
    );
    next?.focus();
  }

  if (e.key === "ArrowUp") {
    e.preventDefault();
    const prev = document.querySelector(
      `[data-row="${rowIndex - 1}"][data-col="${colIndex}"]`
    );
    prev?.focus();
  }

  if (e.key === "ArrowRight") {
    e.preventDefault();
    const next = document.querySelector(
      `[data-row="${rowIndex}"][data-col="${colIndex + 1}"]`
    );
    next?.focus();
  }

  if (e.key === "ArrowLeft") {
    e.preventDefault();
    const prev = document.querySelector(
      `[data-row="${rowIndex}"][data-col="${colIndex - 1}"]`
    );
    prev?.focus();
  }
}



function focusNext(e) {
  if (e.key !== "Enter") return;

  e.preventDefault();

  const form = document.querySelector(".pur-card");
  const focusable = Array.from(
    form.querySelectorAll(
      'input:not([readonly]), select'
    )
  );

  const index = focusable.indexOf(e.target);

  if (index > -1 && focusable[index + 1]) {
    focusable[index + 1].focus();
  }
}

function handlePopupKey(e) {

  const form = document.querySelector(".add-supplier-form");

  if (!form) return;

  const focusable = Array.from(
    form.querySelectorAll("input, button")
  );

  const index = focusable.indexOf(e.target);

  // ENTER = Next
if (e.key === "Enter") {
  e.preventDefault();

  if (index === focusable.length - 2) {
    // If last input field (before Save button)
    focusable[focusable.length - 2].click();
  } else {
    focusable[index + 1]?.focus();
  }
}

  // ARROW DOWN = Next
  if (e.key === "ArrowDown") {
    e.preventDefault();

    if (focusable[index + 1]) {
      focusable[index + 1].focus();
    }
  }

  // ARROW UP = Previous
  if (e.key === "ArrowUp") {
    e.preventDefault();

    if (focusable[index - 1]) {
      focusable[index - 1].focus();
    }
  }

  // ESC = Close
  if (e.key === "Escape") {
    setShowPartyPopup(false);
    setIsAdding(false);
  }
}

const handlePopupSelect = (val)=>{

if(popup.field==="type"){
setHeader(h=>({...h,type:val}));
}

if(popup.field==="item"){

const item = items.find(i=>i.itemName===val);

if(item){

updateRow(popup.rowIndex,{
itemId:item.id,
itemName:item.itemName,
hsnCode:item.hsnCode,
rate:item.rate,
taxPercent:item.taxPercent,
unitValue:item.unitValue,
unitType:item.unitType
});

}

}

};
  /* ---------- UI ---------- */
  return (
    <div className="pur-root">

      <div className="pur-title">PURCHASE</div>

     <div className={`pur-content ${mobileTab === "entry" ? "show-entry" : "show-list"}`}>
 {/* LEFT */}
        <div className="pur-left">
          <div className="pur-card">

            <div className="pur-card-header">Purchase Entry</div>

            <div className="pur-header-row-1">
             <div className="del-field">
  <label>Party Name</label>
  <input
    className="del-input"
    placeholder="Click to select party"
    value={header.partyName}
    readOnly
   onClick={() => {
  setShowPartyPopup(true);
  loadSuppliers();   // 👈 ADD THIS
}}
    onKeyDown={focusNext}
  />
</div>

              <div className="del-field">
                <label>Purchase No</label>
                <input className="pur-input" value={header.purchaseNo} readOnly />
              </div>

              <div className="del-field">
                <label>Date</label>
                <input
                  type="date"
                  className="pur-input"
                  value={header.date}
                  onChange={e => setHeader(h => ({ ...h, date: e.target.value }))}
                  onKeyDown={focusNext}
                />
              </div>
            </div>

            <div className="pur-header-row-2">
              <div className="del-field">
                <label>Address</label>
                <input className="pur-input" value={header.address} readOnly />
              </div>

             <div className="del-field">
  <label>GST No</label>
  <input
    className="del-input"
    value={header.gstNo || ""}
    readOnly
    onKeyDown={focusNext}
  />
</div>
 <div className="del-field">
    <label>Bill No</label>
    <input
      className="pur-input"
      value={header.billNo || ""}
      onChange={e => setHeader(h => ({ ...h, billNo: e.target.value }))}
      onKeyDown={focusNext}
    />
  </div>
              <div className="del-field">
                <label>Type</label>
            <input
className="pur-input"
value={header.type}
placeholder="Select Type"
readOnly
onClick={()=>{
setPopup({
open:true,
field:"type",
title:"Select Type",
options:["Cash","Credit"],
allowAdd:false
});
}}
/>
              </div>
            </div>
{showPartyPopup && (
  <div className="party-popup-overlay">
    <div className="party-popup">

      <div className="party-popup-header">
        <span>Supplier List</span>
        <button onClick={() => {
          setShowPartyPopup(false);
          setIsAdding(false);
        }}>✕</button>
      </div>

      {/* ================= LIST MODE ================= */}
      {!isAdding && (
        <>
          <input
            className="party-popup-search"
            placeholder="Search supplier..."
            value={partySearch}
            onChange={e => setPartySearch(e.target.value)}
            autoFocus
          />

          <div className="party-popup-list">
            {suppliers
              .filter(s =>
                s.name.toLowerCase().includes(partySearch.toLowerCase())
              )
              .map(s => (
                <div
                  key={s.id}
                  className="party-popup-row"
                  onClick={() => {
                    setHeader(h => ({
                      ...h,
                      partyName: s.name,
                      address: s.address,
                      gstNo: s.gstNo   // ✅ IMPORTANT
                    }));
                    setShowPartyPopup(false);
                  }}
                >
                  <div className="party-name">{s.name}</div>
                  <div className="party-place">
                    {s.address}
                    {s.gstNo && ` | GST: ${s.gstNo}`}   {/* ✅ IMPORTANT */}
                  </div>
                </div>
              ))
            }

            {suppliers.length === 0 && (
              <div className="empty-text">No suppliers added</div>
            )}
          </div>

          <div className="add-new-btn-wrap">
            <button
              className="add-new-btn"
              onClick={() => setIsAdding(true)}
            >
              + Add New Supplier
            </button>
          </div>
        </>
      )}

      {/* ================= ADD MODE ================= */}
      {isAdding && (
        <div className="add-supplier-form">

          <div className="form-field">
            <label>Name</label>
            <input
              value={newSupplier.name}
              onChange={e =>
                setNewSupplier({
                  ...newSupplier,
                  name: e.target.value
                })
              }
              onKeyDown={handlePopupKey}
              autoFocus
            />
          </div>

          <div className="form-field">
            <label>Address</label>
            <input
              value={newSupplier.address}
              onChange={e =>
                setNewSupplier({
                  ...newSupplier,
                  address: e.target.value
                })
              }
              onKeyDown={handlePopupKey}
            />
          </div>

          <div className="form-field">
            <label>GST</label>
            <input
              value={newSupplier.gst}
              onChange={e =>
                setNewSupplier({
                  ...newSupplier,
                  gst: e.target.value
                })
              }
              onKeyDown={handlePopupKey}
            />
          </div>

          <div className="add-form-actions">
            <button
              className="primary"
              onClick={async () => {

                if (!newSupplier.name.trim()) return;

                const payload = {
                  name: newSupplier.name,
                  address: newSupplier.address,
                  gstNo: newSupplier.gst   // send as gstNo
                };

                const res = await fetch(SUPPLIER_API, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(payload)
                });

                if (!res.ok) {
                  alert("Supplier already exists");
                  return;
                }

                const saved = await res.json();

                await loadSuppliers();

                setHeader(h => ({
                  ...h,
                  partyName: saved.name,
                  address: saved.address,
                  gstNo: saved.gstNo   // ✅ MUST be gstNo
                }));

                setNewSupplier({ name: "", address: "", gst: "" });
                setIsAdding(false);
                setShowPartyPopup(false);
              }}
            >
              Save
            </button>

            <button
              onClick={() => setIsAdding(false)}
              onKeyDown={handlePopupKey}
            >
              Cancel
            </button>
          </div>

        </div>
      )}

    </div>
  </div>
)}
            {/* TABLE */}
        <div className="pur-table-wrap">
              <table className="pur-table">
                <thead>
                 <tr>
  <th>Item</th>
  <th>HSN</th>
  <th>Qty</th>
  <th>U/A</th>   {/* NEW */}
  <th>Rate</th>
  <th>Tax %</th>
  <th>Amount</th>
  <th>Remarks</th>
</tr>
                </thead>

                <tbody>
                  {rows.map((r, i) => (
                    <tr key={i}>
                      <td>
                       <input
className="pur-cell"
value={r.itemName || ""}
placeholder="Select Item"
readOnly
onClick={()=>{
setPopup({
open:true,
field:"item",
rowIndex:i,
title:"Select Item",
options:items.map(it=>it.itemName),
allowAdd:false
});
}}
/>
                      </td>

                      <td>
                        <input className="pur-cell" value={r.hsnCode} readOnly />
                      </td>

                      <td>
                      <input
  className="pur-cell"
  data-row={i}
  data-col={2}
  value={r.qty}
  onChange={e => updateRow(i, { qty: e.target.value })}
  onKeyDown={e => handleTableEnter(e, i, 2)}
/>
                      </td>

                      <td>
  <input
    className="pur-cell"
    value={r.totalKgDisplay}
    readOnly
  />
</td>

                      <td>
                     <input
  className="pur-cell"
  data-row={i}
  data-col={3}
  value={r.rate}
  onChange={e => updateRow(i, { rate: e.target.value })}
  onKeyDown={e => handleTableEnter(e, i, 3)}
/>
                      </td>

                      <td>
                     <input
  className="pur-cell"
  data-row={i}
  data-col={4}
  value={r.taxPercent}
  onChange={e => updateRow(i, { taxPercent: e.target.value })}
  onKeyDown={e => handleTableEnter(e, i, 4)}
/>
                      </td>

                      <td>
                        <input className="pur-cell" value={r.amount} readOnly />
                      </td>

                      <td>
                     <input
  className="pur-cell"
  data-row={i}
  data-col={6}
  value={r.remarks}
  onChange={e => updateRow(i, { remarks: e.target.value })}
  onKeyDown={e => handleTableEnter(e, i, 6)}
/>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
{/* MOBILE ITEM CARDS */}
<div className="pur-mobile-items">

  {rows.map((r, i) => (

    <div key={i} className="pur-item-card">

      <div className="item-row">
        <label>Item</label>
      <input
value={r.itemName || ""}
placeholder="Select Item"
readOnly
onClick={()=>{
setPopup({
open:true,
field:"item",
rowIndex:i,
title:"Select Item",
options:items.map(it=>it.itemName),
allowAdd:false
});
}}
/>
      </div>

      <div className="item-row">
        <label>HSN</label>
        <input value={r.hsnCode} readOnly />
      </div>

      <div className="item-row">
        <label>Qty</label>
        <input
          value={r.qty}
          onChange={e => updateRow(i,{qty:e.target.value})}
        />
      </div>

      <div className="item-row">
        <label>U/A</label>
        <input value={r.totalKgDisplay} readOnly />
      </div>

      <div className="item-row">
        <label>Rate</label>
        <input
          value={r.rate}
          onChange={e => updateRow(i,{rate:e.target.value})}
        />
      </div>

      <div className="item-row">
        <label>Tax %</label>
        <input
          value={r.taxPercent}
          onChange={e => updateRow(i,{taxPercent:e.target.value})}
        />
      </div>

      <div className="item-row">
        <label>Amount</label>
        <input value={r.amount} readOnly />
      </div>

      <div className="item-row">
        <label>Remarks</label>
        <input
          value={r.remarks}
          onChange={e => updateRow(i,{remarks:e.target.value})}
        />
      </div>

    </div>

  ))}

</div>
<button
className="mobile-add-item"
onClick={addNewRow}
>
+ Add Item
</button>
           <div className="pur-summary">

  <div className="pur-summary-row">
    <div className="summary-field">
      <label>Qty</label>
      <input value={totalQty} readOnly />
    </div>

    <div className="summary-field">
      <label>Bill Amount</label>
      <input value={billAmount.toFixed(2)} readOnly />
    </div>

    <div className="summary-field">
      <label>Tax</label>
      <input value={totalTax.toFixed(2)} readOnly />
    </div>

    <div className="summary-field">
      <label>Grand Amount</label>
      <input value={grandAmount.toFixed(2)} readOnly />
    </div>
  </div>

  <div className="pur-summary-bottom">
    <div className="summary-field discount">
      <label>Discount</label>
      <input
        type="number"
        value={header.discount || ""}
        onChange={e =>
          setHeader(h => ({
            ...h,
            discount: Number(e.target.value || 0)
          }))
        }
      />
    </div>

    <div className="summary-field total">
      <label>Total</label>
      <input value={finalTotal.toFixed(2)} readOnly />
    </div>
  </div>

</div>

            <div className="pur-actions">
           <button
  onClick={handleNew}
  onKeyDown={e => handleButtonKey(e, 0)}
>
  NEW
</button>

<button
  className="primary"
  onClick={handleSave}
  onKeyDown={e => handleButtonKey(e, 1)}
>
  SAVE
</button>

<button
  onClick={goHome}
  onKeyDown={e => handleButtonKey(e, 2)}
>
  EXIT
</button>
            </div>

          </div>
        </div>

        {/* RIGHT */}
        <div className="pur-right">
            <div className="pur-right-card">

          <div className="pur-right-title">Purchase List</div>

          <input
            className="pur-search"
            placeholder="Search party..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

    <div className="pur-list">
  {filteredList.map(p => (
    <div
      key={p.id}
      className="pur-list-row"
    onClick={() => {
  loadPurchaseById(p.id);

  if (window.innerWidth <= 768) {
    setMobileTab("entry");
  }
}}
    >
      <div>{p.purchaseNo}</div>
      <div>{p.partyName}</div>
      <div>₹ {p.totalAmount}</div>
    </div>
  ))}
</div>
        </div>
</div>
      </div>
      <div className="pur-mobile-bottom">

<button
className={mobileTab==="list"?"active":""}
onClick={()=>setMobileTab("list")}
>
Purchase List
</button>

<button
className={mobileTab==="entry"?"active":""}
onClick={()=>setMobileTab("entry")}
>
Entry
</button>

</div>
<button
className="mobile-add-btn"
onClick={()=>setMobileTab("entry")}
>
+
</button>

{popup.open && (

<SelectPopup
title={popup.title}
options={popup.options}
allowAdd={popup.allowAdd}
value=""

onSelect={(val)=>{
handlePopupSelect(val);
}}

onClose={()=>setPopup({...popup,open:false})}

/>

)}
    </div>
  );
}